export const theme = {
  colors: {
    background: '#F8f8f8',
    backgroundModal: '#E9EAEC',
    borderColor: '#9CA5AC',
    red200: 'rgba(192, 12, 48, 0.3)',
    red300: 'rgba(192, 12, 48, 0.56)',
    red500: '#c60c30',

    gray600: '#707070',
    gray500: '#bcbcbc',
    gray400: '#dddddd',

    statusRed: '#c50c30',
    statusYellow: '#ffba00',
    statusGreen: '#0dc70d',

    status2Red: '#c50c30ff',
    status2Orange: '#e77c09ff',
    status2Yellow: '#ffe029ff',
    status2Purple: '#cf51d1ff',
    status2Blue: '#4DC7F9',
    status2Green: '#0ddf0dff',

    greenMain: '#9DF93D',
    blueMain: '#21457F',
    whiteMain: '#FFFFFF',
    greenLogo: '#539F03 ',
    grayMain: '#21457F',
    black: '#0b1613',
    chatGreen: '#9eb200',
  },
};
